import React, {useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import './App.css';

import Header from './Components/Header';

import Home from './Pages/Home';
import Stories from './Pages/Stories';
import Story from './Pages/Story';

function App() {
  // our main app component
  
  const [currentPage, setCurrentPage] = useState('Home-Landing');

  return (
    <div className="App">
      <div
        className='container flex-column main-app-container'
        style={{
          height: '100%',
          width: '100%',
          minWidth: '100%',
          minHeight: '100%',
          paddingBottom: '7%',
          overflow: 'auto',
        }}
      >
        <Header onSetCurrentPage={(page) => setCurrentPage(page)}/>

        <Routes>

          <Route path='/' element={<Home />} />
          <Route path='/stories' element={<Stories />} />
          <Route path='/stories/:story-url' element={<Story />} />
          <Route path='/stories/author/:author' element={<Stories />} />

          {/* future - can incorporate tag filter */}
          {/* <Route path='/stories/tag/:tag' element={<Stories />} /> */}

        </Routes>
        
      </div>
    </div>
  );
}

export default App;
